

















































import Vue from "vue";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";
import Accordion from "@/components/shared/Accordion.vue";
import {
  AddressShipmentDTO,
  MbeServiceDTO,
  ShipmentDTO
} from "@/model/data.model";
import { PriceListService } from "@/services/PriceListService";
import store from "@/vuex/store";
import { Getter, State } from "vuex-class";
import { CurrentLogin, EnvDef } from "@/model/component.model";
import { MBEShipServiceBusiness } from "@/model/enumeration.model";

@Component({
  components: {
    MbeAccordion: Accordion
  }
})
export default class MBEService extends Vue {
  @Prop() shipment: ShipmentDTO;
  @Prop() edition: boolean;
  @Prop({ type: Boolean, default: false }) isInboundShipment: boolean;
  @Prop({ type: Boolean, default: false }) enableAccessPointSelection: boolean;
  @Prop({}) autopilotAvailableMbeServices: number[];
  @Prop({}) isAutopilotEnabled: boolean;
  @Prop({ default: false }) isGel: boolean;
  @PropSync("selectedMbeService") mbeServiceSelected: MbeServiceDTO;
  @Prop({ default: "" }) wineProduct: string;

  @State("currentLogin") currentLogin: CurrentLogin;
  @Getter("features") features: { [key: string]: boolean };
  @Getter("envs") envs: EnvDef;

  accordionOpened = false;
  services: MbeServiceDTO[] = [];

  created() {
    if (this.edition) {
      this.accordionOpened = true;
      this.firstLoadServices();
    }
  }

  changedAccordionState(value: any) {
    this.accordionOpened = value;
  }

  toggleAccessPointsSelectionModal() {
    this.$emit("showAccessPointsModal");
  }

  trySelectingService() {
    // Automatic selection of select service based on courier service (if possible)
    if (this.shipment.courierServiceId !== 0) {
      return store.cache
        .dispatch(
          "cachemod/getMbeServiceForCourierService",
          { idBusinessCourierService: this.shipment.courierServiceId },
          { timeout: store.state["cachemod"].timeouts.mbeServices }
        )
        .then((res: MbeServiceDTO[]) => {
          if (res.length == 1) {
            const serviceExists = this.services.find(
              (service: MbeServiceDTO) =>
                service.idMBEBusiness === res[0].idMBEBusiness
            );
            if (serviceExists) {
              this.selectService(res[0], false);
            } else {
              this.selectedService = null; // not found service on loaded service list
            }
          } else {
            const filteredServices = this.services.filter(
              (item: MbeServiceDTO) => {
                return res[0].idMBEService == item.idMBEService;
              }
            );

            if (filteredServices.length === 1) {
              this.selectService(filteredServices[0], false);
            } else {
              this.selectedService = null;
            }
          }
        });
    } else {
      return Promise.resolve();
    }
  }

  get useCustomerAddressAsSender() {
    return this.$store.getters["customer/config"].customerAddressAsSender;
  }

  firstLoadServices() {
    this.loadServices();
  }

  get wineProductUS() {
    return this.wineProduct === "wine_us" || this.wineProduct === "spirits_us";
  }

  async loadServices(cancelSource: any = undefined): Promise<void> {
    // Load all services for current selected subcountry
    let res: MbeServiceDTO[] = await PriceListService.getMbeServices(
      this.shipment.addressTo.subcountryId,
      cancelSource,
      this.shipment.addressFrom.subcountryId
    );
    //disable MBE ACCESS POINT
    res = res.sort((a: any, b: any) => a.idMBEBusiness - b.idMBEBusiness);

    if (this.isInboundShipment) {
      const deliveryPointService: any = res.find((service: MbeServiceDTO) => {
        return service.idMBEBusiness === 11;
      });
      if (deliveryPointService) {
        res.splice(res.indexOf(deliveryPointService), 1);
      }
    }

    if (this.wineProductUS) {
      res = res.filter(
        (service: MbeServiceDTO) =>
          service.idMBEBusiness === 2 || service.idMBEBusiness === 4
      );
    }

    store.commit("shipment/setMbeServices", res); //set unfiltered to vuex
    const visibilities = this.$store.getters[
      "customer/courierVisibilityConfig"
    ];
    const visible_services = visibilities.filter((item: any) => {
      if (this.shipment.shipmentType !== undefined) {
        if (this.shipment.shipmentType === "INTRAWW" && this.wineProductUS) {
          return item.courierServiceId === 0 && item.shipmentType == "EXPORT";
        }
        return (
          item.courierServiceId === 0 &&
          item.shipmentType == this.shipment.shipmentType
        );
      } else {
        return item.courierServiceId === 0;
      }
    });

    this.services = res.filter(outer => {
      let visible = false;
      visible_services.forEach((inner: any) => {
        if (outer.idMBEService === inner.mbeServiceId) {
          visible = true;
        }
      });

      return visible;
    });
    store.commit("shipment/setVisibleMbeServices", this.services);

    if (!this.isAutopilotEnabled) {
      if (this.services.length == 1) {
        this.selectedService = this.services[0];
      } else {
        const filteredServices = this.services.filter((item: MbeServiceDTO) => {
          return this.isSelectedService(item);
        });

        if (filteredServices.length !== 1) {
          this.trySelectingService();
        }
      }
    }
  }

  wineProductChanged() {
    this.loadServices();
  }

  get selectedService(): MbeServiceDTO | null {
    return null;
  }

  set selectedService(service: MbeServiceDTO | null) {
    if (service != null) {
      this.shipment.mbeServiceId = service.idMBEBusiness;
      this.shipment.mbeService = service.mbeServiceName;
    } else {
      this.shipment.mbeServiceId = 0;
      this.shipment.mbeService = "";
      this.mbeServiceSelected = null as MbeServiceDTO;
    }
  }

  selectService(service: MbeServiceDTO, manual = true) {
    if (
      this.shipment.mbeServiceId != service.idMBEBusiness &&
      this.shipment.mbeService != service.mbeServiceName
    ) {
      this.selectedService = service;
      this.mbeServiceSelected = service;
      if (manual && this.isGel && this.shipment.addressAccessPoint) {
        const blankAddress = new AddressShipmentDTO();
        blankAddress.contact = this.shipment.addressTo.contact;
        blankAddress.phone = this.shipment.addressTo.phone;
        blankAddress.secondPhone = this.shipment.addressTo.secondPhone;
        blankAddress.email = this.shipment.addressTo.email;
        blankAddress.secondEmail = this.shipment.addressTo.secondEmail;
        this.shipment.addressTo = blankAddress;
        this.shipment.addressAccessPoint = undefined;
      }
      this.$emit("mbeServiceModified", service);
    }
  }

  isSelectedService(service: MbeServiceDTO) {
    return (
      service.idMBEBusiness === this.shipment.mbeServiceId &&
      service.mbeServiceName === this.shipment.mbeService
    );
  }

  showService(service: MbeServiceDTO) {
    if (this.isAutopilotEnabled) {
      return (
        this.autopilotAvailableMbeServices.includes(service.idMBEService) ||
        service.idMBEBusiness === MBEShipServiceBusiness.GEL_PROXIMITY_POINT ||
        service.idMBEBusiness === MBEShipServiceBusiness.MBE_ACCESS_POINT
      );
    } else {
      return true;
    }
  }

  getMbeServiceIdBusinessForMbeServiceId(serviceId: number): number {
    const filtered_services = this.services.filter(
      item => item.idMBEService === serviceId
    );

    if (filtered_services.length === 1) {
      return filtered_services[0].idMBEBusiness;
    } else {
      return 0;
    }
  }

  checkCourier() {
    if (this.shipment.courierServiceId !== 0) {
      return false;
    }
    return true;
  }

  @Watch("shipment.shipmentType")
  test() {
    this.loadServices();
  }
}
